import { useMemo } from 'react';
import type { PublicHoliday } from '@techgitter/contracts';
import type { TimeWindowResult } from '@techgitter/contracts';
import { resolveTimeWindow } from '../utils/timeWindowResolver';

export function useAfterHoursSuggestion(
  holidays: PublicHoliday[],
  now?: Date
): TimeWindowResult {
  return useMemo(() => {
    return resolveTimeWindow(now ?? new Date(), holidays);
  }, [holidays, now]);
}
